export const CHART_COLOR_PALETTE = [
  "#2b74e4",
  "#94d0b5",
  "#f6c15f",
  "#8d4fd3",
  "#5d97ee",
  "#5abf8b",
  "#f0a84a",
  "#b07ae9",
] as const;

export const CHART_PRIMARY_COLOR = CHART_COLOR_PALETTE[0];
export const CHART_SECONDARY_COLOR = CHART_COLOR_PALETTE[1];
export const CHART_TERTIARY_COLOR = CHART_COLOR_PALETTE[2];
export const CHART_WARNING_COLOR = CHART_COLOR_PALETTE[3];
export const CHART_DANGER_COLOR = CHART_COLOR_PALETTE[4];

export const CHART_AXIS_STROKE = "#d7dde7";
export const CHART_GRID_STROKE = "#e4e8ef";
export const CHART_TICK_COLOR = "#5e6a7d";
export const CHART_TOOLTIP_CURSOR = "rgba(15, 74, 151, 0.08)";
